import moment from 'moment-timezone'

function readAppointmentTimeZone(appointment: Record<string, unknown> | null | undefined): string {
  const zone =
    appointment?.timeZoneZone ??
    appointment?.TimeZoneZone ??
    appointment?.fK_TimeZone ??
    appointment?.FK_TimeZone
  if (typeof zone === 'string' && zone.trim()) {
    return zone.trim()
  }
  const name = appointment?.timeZoneName ?? appointment?.TimeZoneName
  if (typeof name === 'string' && moment.tz.zone(name)) {
    return name
  }
  return 'UTC'
}

function toMomentInAppointmentTz(
  value: unknown,
  appointment: Record<string, unknown> | null | undefined
): moment.Moment | null {
  if (value == null || value === '') return null
  const tz = readAppointmentTimeZone(appointment)
  const m = moment.utc(value as string | Date)
  if (!m.isValid()) return null
  return m.tz(tz)
}

export function formatAppointmentDate(
  value: unknown,
  appointment: Record<string, unknown> | null | undefined
): string {
  const m = toMomentInAppointmentTz(value, appointment)
  return m ? m.format('MM/DD/YYYY') : ''
}

export function formatAppointmentTime(
  value: unknown,
  appointment: Record<string, unknown> | null | undefined
): string {
  const m = toMomentInAppointmentTz(value, appointment)
  return m ? m.format('h:mm A') : ''
}

export function formatAppointmentDateTime(
  value: unknown,
  appointment: Record<string, unknown> | null | undefined
): string {
  const m = toMomentInAppointmentTz(value, appointment)
  return m ? m.format('MM/DD/YYYY h:mm A') : ''
}

export function formatScheduledDuration(
  start: unknown,
  end: unknown,
  appointment: Record<string, unknown> | null | undefined
): string {
  const mStart = toMomentInAppointmentTz(start, appointment)
  const mEnd = toMomentInAppointmentTz(end, appointment)
  if (!mStart || !mEnd) return ''
  const diff = moment.duration(mEnd.diff(mStart))
  const hours = Math.floor(diff.asHours())
  const minutes = diff.minutes()
  return `${hours} hours ${minutes} minutes`
}

export function formatTravelTime(h: unknown, m: unknown): string {
  const hours = Number(h)
  const minutes = Number(m)
  if (!Number.isFinite(hours) && !Number.isFinite(minutes)) return ''
  if ((hours || 0) === 0 && (minutes || 0) === 0) return ''
  return `${hours || 0}h ${minutes || 0}m`
}

export function joinPhoneLines(...parts: Array<string | null | undefined>): string {
  return parts.map((p) => (p ?? '').trim()).filter(Boolean).join('\n')
}
